import { FC } from 'react';
import { Breadcrumb } from 'antd';

import { IPageBreadcrumb } from './types';
import { Wrapper, StyledLink } from './styled';

// const { Title } = Typography;

const PageBreadcrumb: FC<IPageBreadcrumb> = ({ space, breadcrumbs }) => {
  return (
    <Wrapper space={space}>
      <Breadcrumb>
        {breadcrumbs?.map(b => (
          <Breadcrumb.Item key={b}>
            <StyledLink to={'/' + b}>{b}</StyledLink>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </Wrapper>
  );
};

export default PageBreadcrumb;
